module.exports = __webpack_public_path__ + "static/img/1.5c1ecf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Conference/1.png
// module id = LOHI
// module chunks = 1